import { MqttEventType, MqttEventPayload } from './constants';

export type EventCallback<T extends MqttEventType> = (
  payload: MqttEventPayload[T],
) => void;

type EventCallbackMap = {
  [K in MqttEventType]: Set<(payload: MqttEventPayload[K]) => void>;
};

const listeners: EventCallbackMap = {
  [MqttEventType.VisitVideoEnded]: new Set(),
  [MqttEventType.VisitVideoStarted]: new Set(),
};

export function emitMqttEvent<T extends MqttEventType>(
  eventType: T,
  payload: MqttEventPayload[T],
) {
  const eventListeners = listeners[eventType];

  if (!eventListeners) {
    console.error(`[MQTT] No listeners for event type: ${eventType}`);
    return;
  }

  if (eventListeners) {
    eventListeners.forEach((callback: EventCallback<T>) => callback(payload));
  }
}

export function subscribeToMqttEvent<T extends MqttEventType>(
  eventType: T,
  callback: (payload: MqttEventPayload[T]) => void,
): () => void {
  listeners[eventType].add(callback);

  return () => {
    listeners[eventType].delete(callback);
  };
}
